<template>
    <a-layout>
        <a-layout-sider>
            <div style="height: calc(100vh);">
                <div class="logo">AI混剪</div>
                <a-menu mode="inline" theme="dark" :selected-keys="menu_key">
                    <a-menu-item key="admin/progress">
                        <router-link to="/admin/progress" class="menulink">合成进度</router-link>
                    </a-menu-item>
                    <a-menu-item key="admin/video">
                        <router-link to="/admin/video" class="menulink">合成明细</router-link>
                    </a-menu-item>
                    <a-menu-item key="admin/aistr">
                        <router-link to="/admin/aistr" class="menulink">字幕标题审核</router-link>
                    </a-menu-item>
                   
                    <a-menu-item key="exit" @click="exit">
                        <span>退出</span>
                    </a-menu-item>
                </a-menu>
            </div>
        </a-layout-sider>
        <a-layout>
            <a-layout-content style="height: calc(100vh);">
                <router-view />
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
  
<script>
import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

export default {
    data() {
        return {
            menu_key: [],
        };
    },
    methods: {
        init() {
            var name = this.$route.name;
            this.menu_key = [name];
        },
        exit() {
            var that = this;
            this.$confirm({
                title: '提醒',
                content: '确认退出？',
                cancelText: '取消',
                okText: '确定',
                onOk() {
                    localStorage.removeItem('ai-token');
                    localStorage.removeItem('ai-rolename');
                    that.$router.push('/login')
                },
                onCancel() { },
            });
        }
    },
    created() {
        this.init();
    },
    watch: {
        $route(to, from) {
            this.init();
        },
    },
};
</script>
<style>
body {
    min-width: 1350px;
}

.logo {
    height: 48px;
    color: white;
    text-align: center;
    font-size: 18px;
    font-weight: 800;
    line-height: 48px;
}

.ant-layout-sider {
    flex: 0 0 150px !important;
    min-width: 150px !important;
    text-align: center;
}

.ant-layout-header {
    background-color: white;
    height: 48px;
    border-bottom: 2px solid rgba(0, 21, 41, .08);
    line-height: 48px;
}

.search_content {
    background-color: white;
    margin: 14px;
    border-radius: 10px;
    min-height: calc(100vh - 140px);
}

.btns {
    padding: 10px 0 10px 10px;
}

.search_head {
    background-color: white;
    padding: 10px 30px;
}

.drawer_p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    display: block;
    margin-bottom: 16px;
    margin-top: 16px;
}

.drawer_p2 {
    margin-bottom: 24px;
}
</style>